import { StateObserver } from '../../../lib/pattern/StateMachine';
import { ShuffleEffect } from '../../actions/effects/ShuffleEffect';
import { setAlreadyShuffled, shouldShuffle } from '../../util/matchTools';
import { IPhase, PhaseSystem } from '../PhaseSystem';
import { blockIterateAll } from '../../util/blockTools';
import { getBlockGen } from '../../../match2.util';
import { track } from 'src/lib/analytics/utils';

/*
    handles game session shuffle phase
*/
export class ShufflePhase implements StateObserver, IPhase {
  // fields
  //-------------------------------------------------------------------------
  // input
  private readonly _system: PhaseSystem;

  // init
  //-------------------------------------------------------------------------
  constructor(system: PhaseSystem) {
    this._system = system;
  }

  // impl
  //-------------------------------------------------------------------------
  public async enter() {
    const system = this._system;
    const { scene } = system;
    if (!scene) return;

    // Skip shuffle phase if necessary.
    if (!shouldShuffle(scene)) {
      system.phase = 'transfiguration';
      return;
    }

    // Send analytics event.
    let waterBalloonCount = 0;
    let firecrackerCount = 0;
    let lollipopCount = 0;
    let colorBlockCount = 0;
    blockIterateAll(scene, (base) => {
      switch (base.c.block.props.type) {
        case 'bomb':
          waterBalloonCount++;
          break;
        case 'rocket':
          firecrackerCount++;
          break;
        case 'basic':
          colorBlockCount++;
          break;
        case 'cube':
          lollipopCount++;
          break;
      }
      return false;
    });
    track('Match2AutoShuffle', {
      level: scene.level,
      movesRemaining: scene.moves,
      limitMoves: scene.mapDef?.moves,
      waterBalloonCount,
      firecrackerCount,
      lollipopuCount: lollipopCount,
      colorBlockCount,
      blockGenType: getBlockGen(scene.mapDef!, scene.level),
    });

    // Increment auto shuffle counter.
    scene.usedAutoShuffles++;

    // Execute shuffle effect.
    await new ShuffleEffect(scene).execute();
    setAlreadyShuffled(true);

    // Go to transfiguration phase.
    system.phase = 'transfiguration';
  }

  public async leave() {}

  public step() {}
}
